// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__30wUc","question":"Question_question__3KWM7","description":"Question_description__3cHXO"};